function imageZoom(imgID, resultID, zoomLevel = 2) {
  var img, lens, result, cx, cy;
  img = imgID.querySelector('img');
  result = document.getElementById(resultID);  
  const base = img.src.split('&width=')[0];
  img.src   = `${base}&width=5000`;  
  img.classList.add('img-zoom--active');

  // Create lens
  lens = document.createElement("DIV");
  lens.setAttribute("class", "img-zoom-lens");
  result.appendChild(lens);

  // Set zoom level
  cx = zoomLevel;
  cy = zoomLevel;

  // Background setup
  result.style.backgroundImage = "url('" + img.src + "')";
  result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
  result.style.backgroundPosition = "100% 100%";

  // Event listeners
  lens.addEventListener("mousemove", moveLens);
  img.addEventListener("mousemove", moveLens);
  lens.addEventListener("touchmove", moveLens);
  img.addEventListener("touchmove", moveLens);

  // Close zoom on image click
  img.addEventListener('click', function () {
    img.classList.remove('img-zoom--active');
    result.setAttribute("hidden", "hidden");
    result.removeAttribute("style");
    if (lens && lens.parentNode) {
      lens.remove(); // remove the lens when closing
    }
  });

  function moveLens(e) {
    // Only move if zoom is active
    if (!img.classList.contains('img-zoom--active')) {
      return;
    }

    var pos = getCursorPos(e);
    var x = pos.x - (lens.offsetWidth / 2);
    var y = pos.y - (lens.offsetHeight / 2);

    var maxX = img.width - lens.offsetWidth;
    var maxY = img.height - lens.offsetHeight;

    var clampedX = Math.max(0, Math.min(x, maxX));
    var clampedY = Math.max(0, Math.min(y, maxY));

    lens.style.left = clampedX + "px";
    lens.style.top = clampedY + "px";

    result.style.backgroundPosition = "-" + (clampedX * cx * 0.5) + "px -" + (clampedY * cy * 0.5) + "px";
  }

  function getCursorPos(e) {
    var a, x = 0, y = 0;
    e = e || window.event;
    a = img.getBoundingClientRect();
    x = e.clientX - a.left;
    y = e.clientY - a.top;
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return { x: x, y: y };
  }
}
